'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ReactivateCta = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = require('react-intl');

var _multitrack = require('helpers/multitrack');

var _BaseCtaWithLink = require('./BaseCtaWithLink');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ReactivateCta = function ReactivateCta(_ref) {
  var schedule = _ref.schedule,
      props = (0, _objectWithoutProperties3.default)(_ref, ['schedule']);
  return _react2.default.createElement(
    _BaseCtaWithLink.BaseCtaWithLink,
    (0, _extends3.default)({}, props, {
      className: 'bt--primary bt--outline',
      to: '/rejoin',
      onClick: function onClick() {
        (0, _multitrack.ga)('Venue Details', 'Schedule Join Click', schedule.id);
      }
    }),
    _react2.default.createElement(_reactIntl.FormattedMessage, {
      id: 'schedule.row.cta-join',
      defaultMessage: 'Join'
    })
  );
};

exports.ReactivateCta = ReactivateCta;
ReactivateCta.propTypes = {
  schedule: _propTypes2.default.shape({
    id: _propTypes2.default.number.isRequired
  })
};